import { ColdIcon, WarmIcon, HotIcon, RemittanceIcon, InsuranceIcon, FinancingIcon, ReferralIcon, ReKYCIcon } from "../icons";

import { useState } from "react";
import OpportunityTableButton from "./opportunityTableActionButton";
import SidebarTabsContents from "./sidebar-components/opportunitySidebar.jsx";
import OpportunityCard from "./OpportunityCard";
import { useIsMobile } from "@/hooks";

const OpportunityTable = ({ data, fromAll, refetch }) => {
    const isMobile = useIsMobile();
    const [showSidebar, setShowSidebar] = useState(false);
    const [leadID, setLeadID] = useState(null);
    const [oppID, setOppID] = useState(null);
    const [oppType, setOppType] = useState(null);
    const [statusName, setStatusName] = useState(null);
    const [product, setProduct] = useState(null);
    const [oppName, setOppName] = useState(null);
    const [accName, setAccName] = useState(null);
    const [hunterID, setHunterID] = useState(null);

    const [farmerID, setFarmerID] = useState(null)
    const handleDetailClick = ({oppID, funnel, lead_id}) => {
        console.log(oppID);
        console.log(funnel);
        console.log(lead_id);

        const selectedItem = data.find((item) => item.sub_id === oppID && item.funnel === funnel && item.lead_id === lead_id);

        if( selectedItem ) {
            setShowSidebar(true);
            setLeadID(selectedItem.lead_id);
            setOppID(selectedItem.sub_id);
            setOppType(selectedItem.funnel);
            setAccName(selectedItem.name);
            setStatusName(selectedItem.status_name);
            setProduct(selectedItem.funnel);
            setOppName(selectedItem.opp_name);
            // setHunterID(selectedItem.farmer_id);
        }
    };
    const getOpportunityStatus = (status) => {
        const styles = {
            'Raw Lead': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Fresh Lead': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Profile Completed': "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
            'Activated': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Informaton Gathered': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Onboarded': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Collecting Documents': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Compliance Reviewing': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'KYC Approved': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'To Be Re-KYC': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'KYC Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Preparing Quotations': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Pending Selected': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Pending Payment': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Expired': "bg-[#EEEEEE] border-[#EEEEEE] text-[#94A3B8]"
        };
        return styles[status] || "bg-gray-100 text-gray-600";
    };
    return (
        <>
        <div className="">
            {/* Mobile: Card View */}
            {isMobile ? (
              <div className="space-y-3">
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <OpportunityCard
                      key={`card-${item.sub_id}-${index}`}
                      data={item}
                      fromAll={fromAll}
                      onClick={() => handleDetailClick({oppID: item.sub_id, funnel: item.funnel, lead_id: item.lead_id})}
                    />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    No opportunities found
                  </div>
                )}
              </div>
            ) : (
              /* Desktop: Table View */
              <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
            <thead key="thead">
                <tr key="header-row" className="text-gray-400 border-t">
                    <th key="header-id" className="p-4 border-b text-center w-[5%]">ID</th>
                    <th key="header-name" className="p-4 border-b text-left w-[25%]">Account</th> 
                    <th key="header-oppname" className="p-4 border-b text-left w-[25%]">Opportunity / Remarks / Referred Company</th>
                    <th key="header-product" className="p-4 border-b text-center w-[10%]">Product</th>
                    <th key="header-statusname" className="p-4 border-b text-center w-[20%]">Opportunity Status</th>
                    {fromAll === true ? (
                        <th key="header-farmername" className="p-4 border-b text-center w-[10%]">Owner</th>
                    ) : (
                        null
                    )}
                    <th key="header-action" className="p-4 border-b text-center w-[5%]">Action</th>
                </tr>
            </thead>
            <tbody key="tbody">
                {data.length > 0 ? (
                data.map((item, index) => (
                    <tr key={`row-${item.sub_id}-${index}`} 
                    className="hover:bg-[#F7F7F7]"
                    onClick={() => handleDetailClick({oppID: item.sub_id, funnel: item.funnel, lead_id: item.lead_id})}
                    >
                        <td key={`id-${item.sub_id}`} className="p-4 border-b text-gray-500 text-center w-[5%]">{item.sub_id}</td>
                        <td key={`name-${item.lead_id}`} className="p-4 border-b font-bold text-left w-[25%]">{item.name}</td>
                        <td key={`oppname-${item.lead_id}`} className="p-4 border-b font-bold text-left w-[25%]">{item.opp_name}</td>
                        <td key={`product-${item.sub_id}`} className="p-4 border-b text-center items-center justify-center w-[10%]">
                            <div className="relative group inline-block">
                                <div className="flex items-center justify-center">
                                    {item.funnel.includes('Remittance') && (
                                    <img key={`remittance-${item.sub_id}`} src={RemittanceIcon} alt="Remittance" className="inline-block w-8 h-8 mr-2" />
                                    )}
                                    {item.funnel.includes('Insurance') && (
                                    <img key={`insurance-${item.sub_id}`} src={InsuranceIcon} alt="Insurance" className="inline-block w-8 h-8 mr-2" />
                                    )}
                                    {item.funnel.includes('Financing') && (
                                    <img key={`financing-${item.sub_id}`} src={FinancingIcon} alt="Financing" className="inline-block w-8 h-8 mr-2" />
                                    )}
                                    {item.funnel.includes('Referral') && (
                                    <img key={`referral-${item.sub_id}`} src={ReferralIcon} alt="Referral" className="inline-block w-8 h-8 mr-2" />
                                    )}
                                    {item.funnel.includes('Re-KYC') && (
                                    <img key={`rekyc-${item.sub_id}`} src={ReKYCIcon} alt="ReKYC" className="inline-block w-8 h-8 mr-2" />
                                    )}
                                </div>
                                <div className="absolute hidden group-hover:block bg-gray-800 text-white text-sm rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                                    {item.funnel.includes('Remittance') && (
                                    <span key={`remittance-label-${item.sub_id}`} className="inline-block">Remittance</span>
                                    )}
                                    {item.funnel.includes('Insurance') && (
                                    <span key={`insurance-label-${item.sub_id}`} className="inline-block">Insurance</span>
                                    )}
                                    {item.funnel.includes('Financing') && (
                                    <span key={`financing-label-${item.sub_id}`} className="inline-block">Financing</span>
                                    )}
                                    {item.funnel.includes('Referral') && (
                                    <span key={`referral-label-${item.sub_id}`} className="inline-block">Referral</span>
                                    )}
                                    {item.funnel.includes('Re-KYC') && (
                                    <span key={`rekyc-label-${item.sub_id}`} className="inline-block">Re-KYC</span>
                                    )}
                                </div>
                            </div>
                        </td>
                        <td key={`statusname-${item.sub_id}`} className="p-4 border-b text-center w-[10%]">
                            <span className={`w-[95px] h-[34px] pt-2 px-4 pb-2 gap-2 top-5 left-[22px] rounded-full border font-bold ${getOpportunityStatus(item.status_name)}`}>
                                {item.status_name}
                            </span>
                        </td>
                        { fromAll === true ?  (
                            <td key={`owner-${item.sub_id}`} className="p-4 border-b text-center w-[3%] font-bold">
                                <div className="relative group inline-block">
                                    <span className="bg-[#EEEEEE] w-10 h-10 py-2 px-3 rounded-full inline-flex items-center justify-center">
                                        {item.farmer_name ? item.farmer_name[0].toUpperCase() : ''}
                                    </span>
                                    <div className="absolute hidden group-hover:block bg-gray-800 text-white text-sm rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                                        {item.farmer_name}
                                    </div>
                                </div>
                            </td>
                        ) : (
                            null
                        )}
                        <td key={`action-${item.sub_id}`} onClick={(e) => e.stopPropagation()} className="p-4 border-b text-center w-[2%]">
                            <OpportunityTableButton oppId={item.sub_id} oppType={item.funnel} leadId={item.lead_id} refetch={refetch}/>
                        </td>
                    </tr>
                ))
                ) : (
                <tr key="no-data-row">
                    <td key="no-data-cell" colSpan="4" className="text-center py-4 text-gray-500 border-b">
                        No data available
                    </td>
                </tr>
                )}
            </tbody>
            </table>
            )}
        </div>
        <SidebarTabsContents
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            leadID={leadID}
            oppID={oppID}
            oppType={oppType}
            accName={accName}
            statusName = {statusName}
            product = {product}
            oppName = {oppName}
            hunterID={hunterID}
        />
        </>
    );
  };
  
  export default OpportunityTable;


